import React, { Component } from 'react';
import './Logo.scss';
import {Link} from 'react-router'

class Logo extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        return (
          <div className='main-logo'>
            <span className='logo-over'></span>
            <Link className='logo' to='/'>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </Link>

          </div>
        )
    }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/views/components/Logo/index.js